import { FC, ReactElement } from 'react'
import { Link } from 'react-router-dom'

import './index.css'

export type ExploreCardProps = {
  link: string
  backgroundImage: string
  title: string
}

const ExploreCard: FC<ExploreCardProps> = ({ link, backgroundImage, title }): ReactElement => {
  return (
    <Link
      className="explore-card"
      style={{
        backgroundColor: '#fff',
        boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.2)',
        backgroundImage: `url(${backgroundImage})`,
      }}
      to={link}
      rel="noreferrer"
    >
      <div className="explore-card-overlay"></div>
      <p className="explore-card-title">{title}</p>
    </Link>
  )
}

export default ExploreCard
